import { Pipe, PipeTransform } from '@angular/core';
import { RenderableCell } from 'src/app/element-handling/types';

export function getSpan(cell: RenderableCell, kind: keyof Pick<RenderableCell, 'colspan' | 'rowspan'>): number {
  return cell[kind] !== null ? cell[kind] : 1;
}

@Pipe({
  name: 'rowspan',
  standalone: true
})
export class RowspanPipe implements PipeTransform {
  public transform(cell: RenderableCell): number {
    return getSpan(cell, 'rowspan');
  }
}
